var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-record"},[_c('img',{staticClass:"imgPath",attrs:{"src":require("../assets/img/zanwuxiaoxi@2x.png"),"alt":""}}),_c('br'),_c('p',[_vm._v("暂无记录")])])
}]

export { render, staticRenderFns }